export default __webpack_public_path__ + "022a1ef06756eeb456c4c10e283aa46f.svg";